import React from 'react';
import MusicUploadListItemView from './MusicUploadListItemView';
import CustomUpload from '../../../common/components/CustomUpload';

// アーティスト登録時のアップロードフォームおよび曲の管理のアップロードフォームのRoot Component
export default function MusicUploadListView({
  defaultPermissionToUse,
  onChange,
} : {
  defaultPermissionToUse: number,
  onChange: () => void,
}) {
  const [uploadItems, setUploadItems] = React.useState<{id: string, file: File}[]>([]);
  const [nextUploadId, setNextUploadId] = React.useState(1);

  const addUploadItems = (files: FileList) => {
    const newUploadItems: {id: string, file: File}[] = [];
    for (let i = 0; i < files.length; i += 1) { // FileList
      const data = {
        id: `${nextUploadId + i}`,
        file: files[i],
      };
      newUploadItems.push(data);
    }
    setNextUploadId(nextUploadId + files.length);
    newUploadItems.concat(uploadItems);
    setUploadItems(newUploadItems);
  };

  const removeUploadItem = (uploadId: string) => {
    const a: {id: string, file: File}[] = [];
    const newUploadItems = a.concat(uploadItems);
    const len = newUploadItems.length;
    for (let i = 0; i < len; i += 1) {
      if (newUploadItems[i].id === uploadId) {
        newUploadItems.splice(i, 1);
        break;
      }
    }
    setUploadItems(newUploadItems);
  };

  const musicProcess = uploadItems.map((uploadItem) => (
    <MusicUploadListItemView
      uploadId={uploadItem.id}
      file={uploadItem.file}
      key={uploadItem.id}
      defaultPermissionToUse={defaultPermissionToUse}
      onMusicSave={(uploadId) => { removeUploadItem(uploadId); onChange(); }}
      onMusicCancel={(uploadId) => { removeUploadItem(uploadId); onChange(); }}
    />
  ));
  return (
    <form method="POST" encType="multipart/form-data">
      <div className="form__body">
        <dl>
          <dd>
            <CustomUpload
              type="audio"
              description="mp3 (20MBまで)"
              files={null}
              onSelectFiles={(files) => addUploadItems(files)}
              onDeleteFiles={() => {}}
            />
          </dd>
        </dl>
        <dl>
          <dd>
            {musicProcess}
          </dd>
        </dl>
      </div>
    </form>
  );
}
